import { incrementGetFileProviderItemsRequestCount } from '../helpers/getFileProviderItemsRequestCount';
import FilePickerPanelViewState from '../../store/schema/FilePickerPanelViewState';
import clearFileProviderItems from '../clearFileProviderItems';
import loadMoreItemsForSelectedProvider from '../loadMoreItemsForSelectedProvider';
import { action } from 'satcheljs/lib/legacy';

export default action('startSearch')(function startSearch(
    filePickerPanelViewState: FilePickerPanelViewState,
    query: string
) {
    if (!filePickerPanelViewState.selectedFileProvider.model.IsSearchSupported) {
        throw new Error(
            'Filepicker: Start search should not be called with a provider that does not support search'
        );
    }

    filePickerPanelViewState.filePickerViewState.searchViewState.searchQuery = query;
    filePickerPanelViewState.filePickerViewState.searchViewState.isInSearchMode = true;

    clearFileProviderItems(filePickerPanelViewState.filePickerViewState);
    incrementGetFileProviderItemsRequestCount();
    loadMoreItemsForSelectedProvider(filePickerPanelViewState);
});
